export const UsersTypes = {
  loading: 'users/loading',
  success: 'users/success',
  error: 'users/error',
  secondTable: {
    success: 'secondTable/success',
  },
};
